// extracted by mini-css-extract-plugin
module.exports = {"deleteItem":"_2y4LZqx"};